/** @jsxImportSource @emotion/react */
import { css } from '@mui/material'
import { TOP_NAVBAR_HEIGHT } from '@app/app-constants'

export const liveLayoutContentWrapperStyle = css`
  height: calc(100vh - ${TOP_NAVBAR_HEIGHT}px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`
